(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petsquare-prodotti-popolari"] && !Shopify.designMode) return;
  try {
    
/* PetSquare: cronologia locale, senza invio a servizi esterni. */
(() => {
  if (window.PetSquareHistory) {
    window.PetSquareHistory.trackCurrent();
    return;
  }
  const key = 'petsquare:recently-viewed:v1';
  const maxAge = 30 * 24 * 60 * 60 * 1000;
  const validHandle = value => typeof value === 'string' && /^[a-zA-Z0-9_-]{1,255}$/.test(value);
  let persistentAllowed = false;
  let memory = [];
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(item => validHandle(item.handle) && Number.isFinite(item.at) && Date.now() - item.at < maxAge).slice(0, 40) : [];
    } catch (_) { return []; }
  };
  const get = () => {
    const saved = persistentAllowed ? read() : [];
    return [...memory, ...saved].filter((item, i, all) => all.findIndex(other => other.handle === item.handle) === i).slice(0, 40);
  };
  const add = handle => {
    if (!validHandle(handle)) return;
    memory = [{handle, at: Date.now()}, ...get().filter(item => item.handle !== handle)].slice(0, 40);
    if (persistentAllowed) {
      try { localStorage.setItem(key, JSON.stringify(memory)); } catch (_) { /* Browsing remains usable. */ }
    }
    document.dispatchEvent(new CustomEvent('petsquare:history-change'));
  };
  const trackCurrent = () => {
    document.querySelectorAll('script[data-ps-current-product]').forEach(script => {
      if (script.dataset.psCurrentProduct) add(script.dataset.psCurrentProduct);
    });
  };
  const updatePermission = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    const previous = persistentAllowed;
    persistentAllowed = !!(privacy && privacy.preferencesProcessingAllowed());
    if (!persistentAllowed && previous) {
      memory = [];
      try { localStorage.removeItem(key); } catch (_) {}
    }
    trackCurrent();
    document.dispatchEvent(new CustomEvent('petsquare:history-ready'));
  };
  const api = {get, add, trackCurrent, ready: Promise.resolve()};
  window.PetSquareHistory = api;
  api.ready = new Promise(resolve => {
    const done = () => { updatePermission(); resolve(); };
    if (window.Shopify && window.Shopify.customerPrivacy) done();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], done);
    } else done();
  });
  document.addEventListener('visitorConsentCollected', updatePermission);
  document.addEventListener('trackingConsentAccepted', updatePermission);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-ps-product-handle]');
    if (link) add(link.dataset.psProductHandle);
  });
})();

(() => {
  if (customElements.get('ps-popular-products-v3')) return;
  class PSPopularProducts extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      if (!this.querySelector('[data-ready]')) {
        if (!this.waitingForChildren) {
          this.waitingForChildren = new MutationObserver(() => {
            if (this.querySelector('[data-ready]')) {
              this.waitingForChildren.disconnect();
              this.waitingForChildren = null;
              this.connectedCallback();
            }
          });
          this.waitingForChildren.observe(this, {childList: true, subtree: true});
        }
        return;
      }
      this.started = true;
      this.cfg = JSON.parse(this.querySelector('[data-config]').textContent);
      this.nativeCards = new Map();
      this.cacheNative(this);
      this.list = this.querySelector('[data-list]');
      this.status = this.querySelector('[data-status]');
      this.controls = this.querySelector('[data-controls]');
      this.originalHeading = this.cfg.heading || this.querySelector('[data-heading]').textContent;
      this.retry = this.querySelector('[data-retry]');
      this.events = new AbortController();
      const listen = (node, type, fn) => node.addEventListener(type, fn, {signal: this.events.signal});
      listen(this.retry, 'click', () => this.load());
      listen(this.querySelector('[data-prev]'), 'click', () => this.scroll(-1));
      listen(this.querySelector('[data-next]'), 'click', () => this.scroll(1));
      listen(this.list, 'scroll', () => this.updateControls());
      listen(window, 'resize', () => {
        if (this.renderedItems && this.renderedLimit !== this.visibleLimit()) this.render(this.renderedItems);
        else this.updateControls();
      });
      listen(document, 'petsquare:history-ready', () => { if (this.cfg.mode === 'recent') this.load(); });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.list);
      }
      this.load();
    }
    disconnectedCallback() {
      this.events?.abort(); this.request?.abort(); this.resizeObserver?.disconnect(); this.waitingForChildren?.disconnect(); this.waitingForChildren = null; this.started = false;
    }
    async getJSON(url, controller) {
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return await response.json();
      } finally { clearTimeout(timeout); }
    }
    async getPage(url, controller) {
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = doc.querySelector('[data-ps-products-feed]');
        if (!data) throw new Error('Feed mancante');
        const result = JSON.parse(data.textContent);
        this.cacheNative(doc);
        return result;
      } finally { clearTimeout(timeout); }
    }
    normalize(product, discountMode = false) {
      if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
      const available = product.variants.filter(v => v.available);
      const pool = available.length ? available : product.variants;
      const percent = v => Number(v.compare_at_price) > Number(v.price) && Number(v.compare_at_price) > 0
        ? (Number(v.compare_at_price) - Number(v.price)) / Number(v.compare_at_price) * 100 : 0;
      const variant = [...pool].sort(discountMode
        ? (a, b) => percent(b) - percent(a) || Number(a.price) - Number(b.price)
        : (a, b) => Number(a.price) - Number(b.price))[0];
      return {product, variant, discount: percent(variant), available: available.length > 0,
        varies: pool.some(v => Number(v.price) !== Number(variant.price))};
    }
    eligible(item, discountMode = false) {
      return item && (!this.cfg.hideSoldOut || item.available) && (!discountMode || item.discount > 0 && item.discount + 1e-8 >= this.cfg.minDiscount);
    }
    async collectionProducts(mode, controller) {
      const url = new URL(this.cfg.source, location.origin);
      url.searchParams.set('section_id', 'petsquare-products-feed');
      url.searchParams.delete('page');
      url.searchParams.delete('sort_by');
      if (mode === 'bestselling') url.searchParams.set('sort_by', 'best-selling');
      if (mode === 'newest') url.searchParams.set('sort_by', 'created-descending');
      const isDiscount = mode === 'discount';
      const items = [];
      const ids = new Set();
      const visited = new Set();
      let next = url;
      while (next && (isDiscount || this.cardCount(items) < this.cfg.limit)) {
        if (controller.signal.aborted) throw new DOMException('Aborted', 'AbortError');
        if (visited.has(next.href)) throw new Error('Paginazione duplicata');
        visited.add(next.href);
        const page = await this.getPage(next, controller);
        for (const product of page.products) {
          if (ids.has(product.id)) continue;
          ids.add(product.id);
          const item = this.normalize(product, isDiscount);
          if (this.eligible(item, isDiscount)) items.push(item);
        }
        // La modalità sconti confronta l'intera collezione, non solo la prima pagina.
        if (isDiscount && page.next) this.status.textContent = 'Cerchiamo le migliori offerte…';
        next = page.next ? new URL(page.next, location.origin) : null;
        if (next) {
          if (next.origin !== location.origin) throw new Error('Origine feed non valida');
          next.searchParams.set('section_id', 'petsquare-products-feed');
          if (mode === 'bestselling') next.searchParams.set('sort_by', 'best-selling');
          if (mode === 'newest') next.searchParams.set('sort_by', 'created-descending');
        }
      }
      if (isDiscount) items.sort((a, b) => b.discount - a.discount || Number(a.variant.price) - Number(b.variant.price));
      return items.slice(0, this.cfg.limit);
    }
    async recentlyViewed(controller) {
      if (window.PetSquareHistory) await window.PetSquareHistory.ready;
      const history = window.PetSquareHistory?.get() || [];
      const handles = history.map(item => item.handle).filter(handle => !this.cfg.excludeCurrent || handle !== this.cfg.currentHandle);
      const result = [];
      // Piccoli gruppi in parallelo, conservando l'ordine della cronologia.
      for (let i = 0; i < handles.length && this.cardCount(result) < this.cfg.limit; i += 4) {
        const batch = await Promise.all(handles.slice(i, i + 4).map(async handle => {
          try {
            const root = this.cfg.root.replace(/\/?$/, '/');
            const url = root + 'products/' + encodeURIComponent(handle) + '?section_id=petsquare-products-feed';
            const page = await this.getPage(url, controller);
            return this.normalize(page.products[0]);
          } catch (error) { if (controller.signal.aborted) throw error; return null; }
        }));
        result.push(...batch.filter(item => this.eligible(item)));
      }
      return result.slice(0, this.cfg.limit);
    }
    async load() {
      this.request?.abort();
      const controller = new AbortController();
      this.request = controller;
      this.hidden = false; this.retry.hidden = true;
      this.pendingHeading = this.originalHeading;
      this.status.hidden = false; this.status.textContent = 'Caricamento prodotti…';
      this.list.setAttribute('aria-busy', 'true');
      try {
        let items;
        if (this.cfg.mode === 'manual') {
          items = this.cfg.manual.map(p => this.normalize(p)).filter(i => this.eligible(i)).slice(0, this.cfg.limit);
        } else if (this.cfg.mode === 'recent') {
          items = await this.recentlyViewed(controller);
          if (!items.length && this.cfg.emptyBehavior === 'bestselling') {
            items = await this.collectionProducts('bestselling', controller);
            this.pendingHeading = this.cfg.customHeading || this.cfg.fallbackTitle || this.originalHeading;
          } else if (!items.length && this.cfg.emptyBehavior === 'hide') {
            if (this.request === controller) this.hidden = !(window.Shopify && window.Shopify.designMode);
          }
        } else items = await this.collectionProducts(this.cfg.mode, controller);
        if (this.request !== controller || controller.signal.aborted) return;
        const rendered = this.render(items);
        this.status.textContent = rendered ? '' : 'Nessun prodotto disponibile in questa selezione.';
        this.status.hidden = rendered > 0;
      } catch (error) {
        if (this.request !== controller || !this.isConnected) return;
        // Conserva le card Liquid già presenti se il caricamento dinamico fallisce.
        this.controls.hidden = true;
        console.warn('[PetSquare prodotti]', error);
        this.status.textContent = this.list.querySelector('.psp-item') ? 'La selezione iniziale è visibile. Riprova per aggiornarla.' : 'Non riusciamo a caricare i prodotti. Riprova tra poco.';
        this.status.hidden = false; this.retry.hidden = false;
      } finally {
        if (this.request === controller) this.list.setAttribute('aria-busy', 'false');
      }
    }
    cacheNative(root) {
      root.querySelectorAll('[data-ps-native-product]').forEach(group => this.nativeCards.set(String(group.dataset.psNativeProduct), group));
    }
    templates(item) {
      const group = this.nativeCards.get(String(item.product.id));
      if (!group) return [];
      let cards;
      if (this.cfg.mode === 'discount') cards = [...group.querySelectorAll('template[data-ps-variant-card]')].filter(t => t.dataset.psVariantCard === String(item.variant.id)).slice(0, 1);
      else cards = [...group.querySelectorAll(this.cfg.splitColors ? 'template[data-ps-default-card]' : 'template[data-ps-product-card]')];
      return cards.filter(t => !this.cfg.hideSoldOut || t.dataset.available === 'true');
    }
    cardCount(items) { return items.reduce((total, item) => total + this.templates(item).length, 0); }
    namespaceIDs(node, prefix) {
      const ids = new Map();
      node.querySelectorAll('[id]').forEach(el => { const old = el.id; const replacement = prefix + '-' + old; ids.set(old, replacement); el.id = replacement; });
      node.querySelectorAll('*').forEach(el => {
        for (const attr of ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns', 'headers']) {
          if (el.hasAttribute(attr)) el.setAttribute(attr, el.getAttribute(attr).split(/\s+/).map(id => ids.get(id) || id).join(' '));
        }
        for (const attr of ['href', 'data-modal']) {
          const value = el.getAttribute(attr);
          if (value?.startsWith('#') && ids.has(value.slice(1))) el.setAttribute(attr, '#' + ids.get(value.slice(1)));
        }
      });
    }
    visibleLimit() {
      const mobile = matchMedia('(max-width: 749px)').matches;
      return Number(mobile ? this.cfg.limitMobile || this.cfg.limit : this.cfg.limitDesktop || this.cfg.limit);
    }
    render(items) {
      this.renderedItems = items;
      const visibleLimit = this.visibleLimit();
      this.renderedLimit = visibleLimit;
      const fragment = document.createDocumentFragment();
      let count = 0;
      for (const item of items) {
        for (const template of this.templates(item)) {
          if (count >= visibleLimit) break;
          const li = document.createElement('li');
          li.className = 'grid__item psp-item';
          const contents = template.content.cloneNode(true);
          // Si inserisce l'HTML Liquid degli snippet del tema, senza ricostruire prezzi, badge o recensioni.
          this.namespaceIDs(contents, this.id + '-native-' + count);
          const ratio = this.cfg.imageRatio === 'portrait' ? 125 : this.cfg.imageRatio === 'adapt'
            ? 100 / (Number(template.dataset.ratio) || 1) : 100;
          contents.querySelectorAll('.card--media, .card__inner.ratio').forEach(el => el.style.setProperty('--ratio-percent', ratio + '%', 'important'));
          contents.querySelectorAll('a[href]').forEach(link => {
            const url = new URL(link.getAttribute('href'), location.origin);
            if (url.pathname.includes('/products/')) link.dataset.psProductHandle = item.product.handle;
          });
          li.append(contents);
          fragment.append(li);
          count++;
        }
        if (count >= visibleLimit) break;
      }
      if (items.length && !count) throw new Error('Card native mancanti: controllare petsquare-native-cards.liquid e petsquare-products-feed.liquid');
      this.list.replaceChildren(fragment);
      this.querySelector('[data-heading]').textContent = this.pendingHeading || this.originalHeading;
      this.list.setAttribute('aria-label', this.querySelector('[data-heading]').textContent);
      this.list.scrollLeft = 0;
      this.updateControls();
      // Le app di recensioni possono reagire all'inserimento di markup dinamico.
      this.dispatchEvent(new CustomEvent('petsquare:cards-rendered', {bubbles: true, detail: {sectionId: this.id}}));
      return count;
    }
    

    scrollBounds() {
  const cards = [...this.list.querySelectorAll('.psp-item')]
    .filter(card => card.getClientRects().length);

  if (!cards.length) return { min: 0, max: 0 };

  const listRect = this.list.getBoundingClientRect();
  const lastRect = cards[cards.length - 1].getBoundingClientRect();

  return {
    min: 0,
    max: Math.max(
      0,
      lastRect.right - listRect.right + this.list.scrollLeft
    )
  };
}

scroll(direction) {
  const { min, max } = this.scrollBounds();
  const target = Math.min(
    max,
    Math.max(
      min,
      this.list.scrollLeft + direction * this.list.clientWidth
    )
  );

  this.list.scrollTo({
    left: target,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth'
  });
}

updateControls() {
  const { min, max } = this.scrollBounds();
  const mobile = matchMedia('(max-width: 749px)').matches;

  const enabled = mobile
    ? this.dataset.scrollMobile === 'true'
    : this.dataset.scrollDesktop === 'true';

  const showNav = mobile
    ? this.dataset.navMobile !== 'false'
    : this.dataset.navDesktop !== 'false';

  this.controls.hidden = !enabled || !showNav || max <= 2;

  this.querySelector('[data-prev]').disabled =
    this.list.scrollLeft <= min + 2;

  this.querySelector('[data-next]').disabled =
    this.list.scrollLeft >= max - 2;
}



  }
  customElements.define('ps-popular-products-v3', PSPopularProducts);
  document.addEventListener('shopify:section:load', event => {
    const sections = event.target.matches('ps-popular-products-v3') ? [event.target] : event.target.querySelectorAll('ps-popular-products-v3');
    sections.forEach(section => {
      section.disconnectedCallback();
      section.connectedCallback();
    });
    window.PetSquareHistory?.trackCurrent();
  });
  document.addEventListener('shopify:section:unload', event => {
    const sections = event.target.matches('ps-popular-products-v3') ? [event.target] : event.target.querySelectorAll('ps-popular-products-v3');
    sections.forEach(section => section.disconnectedCallback());
  });
})();


  } catch(e) { console.error(e); }
})();
})();
